import { motion } from "framer-motion";

export default function Maintenance() {
  return (
    <section
      className="relative py-20 px-6 text-white"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.85) 0%, rgba(249,122,8,0.3) 100%), url('/assets/s1.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Content Wrapper */}
      <div className="max-w-5xl mx-auto">
        {/* 🔥 Heading */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-orange-400 mb-4">
            Solar Maintenance Services 🔧
          </h2>

          <p className="text-white/80 leading-relaxed max-w-2xl mx-auto">
            Ensure maximum performance and long-term reliability of your solar
            system with our professional maintenance services. We help you
            protect your investment, reduce energy loss, and keep your system
            running efficiently all year round.
          </p>
        </motion.div>

        {/* 🔥 SECTIONS */}
        <div className="space-y-16">
          {[
            {
              title: "Preventive Maintenance",
              desc: `Preventive maintenance is essential to keep your solar system operating at peak efficiency. 
Regular inspections help identify potential issues before they become major problems. 
Cleaning panels, checking wiring, and inspecting inverters are part of this process. 
It improves system lifespan and ensures consistent performance. 
Prevents unexpected breakdowns and costly repairs. 
Maintains optimal energy production levels. 
Reduces system downtime significantly. 
Helps detect early signs of wear and tear. 
Ideal for both residential and commercial setups. 
A proactive approach to system care.`,
            },
            {
              title: "Corrective Maintenance",
              desc: `Corrective maintenance focuses on fixing issues after they occur. 
It includes repairing faulty components and replacing damaged parts. 
Ensures system returns to full functionality quickly. 
Minimizes energy production losses. 
Handled by experienced technical professionals. 
Includes inverter repair, wiring fixes, and panel issues. 
Essential for restoring system efficiency. 
Prevents long-term damage. 
Improves overall reliability of the system. 
A necessary service for long-term sustainability.`,
            },
            {
              title: "Panel Cleaning Services",
              desc: `Solar panels accumulate dust, dirt, and debris over time. 
This reduces their efficiency and energy output. 
Professional cleaning restores optimal performance. 
Ensures maximum sunlight absorption. 
Improves overall energy generation. 
Safe cleaning methods prevent panel damage. 
Recommended regularly in dusty environments. 
Helps maintain system efficiency. 
Increases return on investment. 
A simple yet highly effective service.`,
            },
            {
              title: "System Inspection & Testing",
              desc: `Regular system inspection ensures all components are working properly. 
Includes checking electrical connections and inverter performance. 
Detects hidden faults and inefficiencies. 
Provides detailed performance reports. 
Helps maintain system safety standards. 
Ensures compliance with technical requirements. 
Improves long-term system reliability. 
Supports better energy planning. 
Essential for large-scale systems. 
A complete system health check solution.`,
            },
            {
              title: "Performance Optimization",
              desc: `Performance optimization focuses on improving system efficiency. 
Analyzes energy production and consumption patterns. 
Identifies areas for improvement. 
Enhances output through smart adjustments. 
Reduces energy wastage. 
Improves system lifespan. 
Supports maximum ROI. 
Ideal for modern solar installations. 
Ensures optimal performance at all times. 
A smart approach to energy management.`,
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="text-center bg-black/40 backdrop-blur-md p-6 rounded-xl border border-orange-500/20 hover:border-orange-400 hover:shadow-[0_0_25px_rgba(249,115,22,0.4)] transition"
            >
              <h3 className="text-2xl font-bold text-orange-400 mb-4">
                {item.title}
              </h3>

              <p className="text-white/80 leading-relaxed whitespace-pre-line">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
